// BusinessQuotePage.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Building, Truck, Calendar, Mail, Phone, ChevronRight } from 'lucide-react';

const BusinessQuotePage = ({ isMobile }) => {
  return (
    <div className="min-h-screen bg-gray-50 pt-16 md:pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-cyan-500 py-12 md:py-16 px-4 relative overflow-hidden">
        {/* Background pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-full h-full bg-white" 
               style={{backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'}}></div>
        </div>
        
        <div className="max-w-4xl mx-auto relative">
          <div className="text-center text-white">
            <h1 className="text-3xl md:text-5xl font-bold mb-4">Business Detailing Solutions</h1>
            <div className="w-20 h-1 bg-white/30 mx-auto mb-6"></div>
            <p className="text-white/90 max-w-xl mx-auto">
              Select the type of business quote you'd like to request
            </p>
          </div>
        </div>
      </section>
      
      {/* Quote Type Selection */}
      <section className="py-12 md:py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Fleet Services Card */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-40 bg-blue-600 relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-500"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <Truck className="h-20 w-20 text-white/80" />
                </div>
              </div>
              
              <div className="p-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-3">Fleet Detailing Services</h2>
                <p className="text-gray-600 mb-6">
                  Specialized maintenance programs for company vehicles, delivery fleets, and corporate cars.
                  Streamline your fleet's appearance with our mobile detailing services.
                </p>
                
                <div className="mt-4">
                  <Link to="/fleet-quote" className="inline-flex items-center gap-2 text-blue-600 font-medium hover:text-blue-800 transition-colors">
                    Request Fleet Quote
                    <ChevronRight className="h-5 w-5" />
                  </Link>
                </div>
              </div>
            </div>
            
            {/* Dealership Services Card */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-40 bg-cyan-600 relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-cyan-600 to-cyan-500"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <Building className="h-20 w-20 text-white/80" />
                </div>
              </div>
              
              <div className="p-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-3">Dealership Detailing</h2>
                <p className="text-gray-600 mb-6">
                  Comprehensive solutions for new and used car dealerships. Keep your inventory 
                  looking showroom-ready and maximize selling potential.
                </p>
                
                <div className="mt-4">
                  <Link to="/dealership-quote" className="inline-flex items-center gap-2 text-blue-600 font-medium hover:text-blue-800 transition-colors">
                    Request Dealership Quote
                    <ChevronRight className="h-5 w-5" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          
          <div className="mt-12 text-center">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Need a Different Business Solution?</h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Contact our business services team directly to discuss custom solutions for your specific requirements.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <div className="flex items-center justify-center gap-2">
                <Phone className="h-5 w-5 text-blue-500" />
                <a href="tel:+12345678900" className="text-blue-600 hover:underline">
                  (234) 567-8900
                </a>
              </div>
              
              <div className="flex items-center justify-center gap-2">
                <Mail className="h-5 w-5 text-blue-500" />
                <a href="mailto:business@jpautodetailing.com" className="text-blue-600 hover:underline">
                  business@jpautodetailing.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BusinessQuotePage;